import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const RebalancingIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="m 28.67335,48.276552 c 11.408307,0 20.656562,-9.248255 20.656562,-20.656563 0,-11.408307 -9.248255,-20.6565914 -20.656562,-20.6565914 -11.408385,0 -20.6566179,9.2482844 -20.6566179,20.6565914 0,11.408308 9.2482329,20.656563 20.6566179,20.656563 z"
        fill="#52c700"
        stroke="#52c700"
        strokeWidth="2.60242"
        strokeLinecap="round"
        strokeLinejoin="round"
        id="path4020"
      />
      <path
        d="M 39.307431,37.575117 H 18.257337 v 2.792146 h 21.050094 z"
        fill="#ffffff"
        stroke="#ffffff"
        strokeWidth="0.866828"
        strokeLinecap="round"
        strokeLinejoin="round"
        id="path4022"
      />
      <path
        d="M 29.371482,11.747992 H 27.97537 v 25.827279 h 1.396112 z"
        fill="#ffcb06"
        stroke="#ffffff"
        strokeWidth="1.87225"
        strokeLinejoin="round"
        id="path4024"
      />
      <path
        d="m 15.243332,18.35712 3.497626,-0.108338 c 5.532559,-5.547268 13.908689,-5.613268 19.544791,-0.08747 l 3.482083,-0.01315"
        stroke="#ffffff"
        strokeWidth="2.11059"
        strokeLinecap="round"
        id="path4026"
      />
      <path
        d="m 35.642773,35.13196 h -13.7207 v 2.09409 h 13.7207 z"
        fill="#ffffff"
        stroke="#ffffff"
        strokeWidth="0.606068"
        strokeLinejoin="round"
        id="path4028"
      />
      <path
        d="m 22.709444,26.057774 c 0,0.586392 -0.258048,1.162499 -0.748165,1.670323 -0.490116,0.507825 -1.195054,0.929504 -2.04398,1.222739 -0.848927,0.293157 -1.811915,0.447507 -2.792147,0.447507 -0.980232,0 -1.943221,-0.15435 -2.792147,-0.447507 -0.848888,-0.293235 -1.55384,-0.714914 -2.043957,-1.222739 -0.490125,-0.507824 -0.748158,-1.083931 -0.748158,-1.670323 h 5.584262 z"
        fill="#ffffff"
        id="path4030"
        strokeWidth="0.773297"
      />
      <path
        d="m 12.237779,26.020578 4.888146,-6.94344 4.954132,6.94344"
        stroke="#ffffff"
        strokeWidth="1.31912"
        strokeLinecap="round"
        id="path4032"
      />
      <path
        d="m 45.805762,26.178795 c 0,0.586391 -0.257973,1.162498 -0.748165,1.670323 -0.490117,0.507825 -1.195056,0.929505 -2.043982,1.222738 -0.848927,0.293158 -1.811837,0.447509 -2.792146,0.447509 -0.980232,0 -1.94322,-0.154351 -2.792146,-0.447509 -0.848849,-0.293233 -1.553865,-0.714913 -2.04398,-1.222738 -0.490117,-0.507825 -0.74809,-1.083932 -0.74809,-1.670323 h 5.584216 z"
        fill="#ffffff"
        id="path4034"
        strokeWidth="0.773297"
      />
      <path
        d="m 35.333454,26.141985 4.888789,-6.94344 4.953513,6.94344"
        stroke="#ffffff"
        strokeWidth="1.31912"
        strokeLinecap="round"
        id="path4036"
      />
      <path
        d="m 27.787073,37.428344 c 0.19897,-0.953939 0.869263,-1.741234 1.779126,-2.089914 l 19.313189,-7.401156 c 1.477308,-0.566131 3.133944,0.172523 3.700075,1.649831 l 4.047905,10.562939 c 0.566132,1.477307 -0.172522,3.133867 -1.649908,3.700074 l -19.353787,7.416777 c -0.887515,0.340097 -1.885997,0.217838 -2.665248,-0.326332 l -5.424066,-3.787844 c -0.940408,-0.656685 -1.398432,-1.810986 -1.164123,-2.933737 z"
        fill="#1e43f9"
        id="path4038"
        strokeWidth="0.773297"
      />
      <path
        d="m 35.040142,35.567172 1.749045,4.564158 -1.100248,0.421679 -1.749122,-4.564159 z m 1.37299,-0.526152 0.325559,0.849545 -3.814988,1.46192 -0.325558,-0.849469 z m 2.386396,0.185591 0.268645,4.031433 -1.181831,0.452843 -0.072,-5.206845 0.749248,-0.287126 z m 2.303114,3.251795 -2.497443,-3.177327 -0.511846,-0.903907 0.758606,-0.29076 3.435607,3.917913 z M 40.406441,36.793081 40.732,37.642548 38.3903,38.53996 38.064819,37.690415 Z m 1.423565,-3.827902 1.327443,1.231322 0.164635,-1.803098 1.253902,-0.480528 -0.405362,2.751008 2.188973,1.799928 -1.266429,0.485321 -1.360308,-1.251118 -0.175771,1.839753 -1.269523,0.486558 0.428562,-2.80305 -2.143196,-1.774331 z m -5.132377,10.248206 1.749121,4.564158 -1.100325,0.42168 -1.749044,-4.564235 z m 2.502237,1.219723 0.324398,0.846374 -2.087749,0.800054 -0.324399,-0.846374 z m -0.549274,-1.96812 0.325558,0.849467 -2.266458,0.868568 -0.325559,-0.849545 z m 0.457637,-0.175384 1.796216,-0.68839 c 0.351077,-0.134553 0.676249,-0.199201 0.975439,-0.19402 0.299189,0.0052 0.558011,0.08336 0.776468,0.234464 0.220622,0.150328 0.388582,0.375977 0.50388,0.676944 0.100143,0.261221 0.143061,0.49522 0.128831,0.702 -0.01423,0.206779 -0.07245,0.395697 -0.174687,0.566673 -0.100993,0.168114 -0.233536,0.325557 -0.397785,0.472408 l -0.282408,0.341874 -1.507776,0.577886 -0.331822,-0.847148 1.115947,-0.427633 c 0.140043,-0.05367 0.246372,-0.123187 0.319139,-0.208636 0.0727,-0.08537 0.114448,-0.182808 0.125197,-0.292384 0.01199,-0.112515 -0.0068,-0.233537 -0.05645,-0.363063 -0.0505,-0.131694 -0.117773,-0.235315 -0.20183,-0.310944 -0.08414,-0.07563 -0.182808,-0.120479 -0.296097,-0.134631 -0.111122,-0.01492 -0.234618,0.0037 -0.370486,0.05575 l -0.69589,0.266634 1.423486,3.71469 -1.100249,0.421679 z m 4.247493,3.606738 -1.782992,-1.631968 1.163658,-0.453152 1.779977,1.58642 0.01802,0.04702 z m 4.506238,-2.697572 0.324398,0.846375 -2.432563,0.93221 -0.32432,-0.846374 z m -3.465379,-2.935748 1.749045,4.564158 -1.100325,0.421602 -1.749046,-4.564158 z m 2.421583,1.149894 0.313495,0.818227 -2.119069,0.81204 -0.313572,-0.818149 z m -0.371493,-1.935564 0.325558,0.849467 -2.441997,0.935846 -0.325558,-0.849545 z m 5.007721,2.344716 0.324322,0.846374 -2.432486,0.932211 -0.324399,-0.846374 z m -3.465457,-2.935748 1.749123,4.564158 -1.100326,0.42168 -1.749045,-4.564236 z m 2.421583,1.149972 0.313573,0.818149 -2.119069,0.81204 -0.313572,-0.818149 z m -0.371415,-1.935642 0.325481,0.849545 -2.441919,0.935768 -0.325559,-0.849468 z"
        fill="#ffffff"
        id="path4040"
        strokeWidth="0.773297"
      />
      <circle cx="30.475983" cy="44.366371" r="2.013242" fill="#ffffff" id="circle4042" strokeWidth="0.773297" />
    </SvgIcon>
  );
};

export default RebalancingIcon;
